// Hausschrift des Email-Editors (components/form/EmailEditor) – je Kunde wie in den Mail-Vorlagen (template/*/TopPart.js)
export const HOUSE_FONT = {
    label: 'Open Sans',
    family: "'Open Sans',sans-serif",
};
